import { Component, OnInit } from '@angular/core';
import { RokoviTrajanjaService } from './rokovitrajanja.service';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';

@Component({
  selector: 'app-rokovitrajanja',
  templateUrl: './rokovitrajanja.component.html',
  styleUrls: ['./rokovitrajanja.component.scss'],
  providers: [RokoviTrajanjaService]
})

export class RokovitrajanjaComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');

  lotRokovi: any = [];
  svaSkladista: any = [];
  //dohvaca sve artikle/proizvode
  aktivan: any = undefined;
  proizvodi: any = [];
  rokArray: any = [
    { predistekomroka: 0, naziv_rok: 'SVE' },
    { predistekomroka: 1, naziv_rok: 'DA' }
  ];
  idposlovnica: any = undefined;
  idartikl: any = undefined;
  predistekomroka: any = 0;
  poruka: any;


  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private _rokoviTrajanjaService: RokoviTrajanjaService) {

    this.svaSkladista = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];
    this.proizvodi = [{ idartikl: undefined, sifra_i_naziv_artikla: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().rokoviTrajanja;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit(): void {
    this.dohvatiSkladista_Pekar_i_Tomo();
    this.dohvatiProizvode();
    this.dohvatiRokoveTrajanja();
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(e) {
    //console.log(e);
    //console.log(e.rowType);
    //console.log(e.column.dataField);
    if(e.rowType == "data" && e.data.upozorenje == 1){
      /*
      //baš za određenu čeliju ako želimo da naznači
      if (e.column.dataField === 'ar_sifra') {
        //e.cellElement.style.color = "red";
        //e.cellElement.style.backgroundColor = "red";
      }
      */
      e.cellElement.style.color = "red";
    }
  }

  dohvatiSkladista_Pekar_i_Tomo() {
    this._rokoviTrajanjaService.dohvatiSkladista_Pekar_i_Tomo({}).subscribe((res) => {
      //console.log('SKLADIŠTA: ', res);
      this.svaSkladista = [];
      this.svaSkladista = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];
      if (res.success == true) {
        for (let i = 0; i < res.data.length; i++) {
          this.svaSkladista.push({
            idposlovnica: res.data[i].idposlovnica,
            po_naziv_prikaz: res.data[i].po_naziv_prikaz
          });
        }
        //console.log('SVA SKLADIŠTA:', this.svaSkladista);
      }
    });
  }

  dohvatiProizvode() {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      ar_aktivan: this.aktivan
    }
    //console.log(podaciZaSlanje);
    this.proizvodi = [];
    this.proizvodi = [{ idartikl: undefined, sifra_i_naziv_artikla: 'SVE' }];
    this._rokoviTrajanjaService.dohvatiSveProizvode(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        for (let data of res.data) {
          let arr = { idartikl: data.ar_id, sifra_i_naziv_artikla: data.ar_sifra + ' ' + data.ar_naziv };
          this.proizvodi.push(arr);
        }
        //console.log(this.proizvodi);
      }
    });
  }

  promjenaSkladista(e){
    //console.log(e);
    //console.log(e.value);
    this.idposlovnica = e.value;
    this.dohvatiRokoveTrajanja();
  }

  promjenaArtikla(e){
    //console.log(e);
    //console.log(e.value);
    if (e.value == null) {
      this.idartikl = undefined;
    } else {
      this.idartikl = e.value;
    }
    this.dohvatiRokoveTrajanja();
  }

  promjenaRoka(e){
    //console.log(e);
    //console.log(e.value);
    this.predistekomroka = e.value;
    this.dohvatiRokoveTrajanja();
  }

  dohvatiRokoveTrajanja(){
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      idfirma: this.idfirma,
      idposlovnica: this.idposlovnica,
      idartikl: this.idartikl,
      predistekomroka: this.predistekomroka
    }
    //console.log(podaciZaSlanje);
    this.lotRokovi = [];
    this.poruka = 'Učitavanje...';
    this._rokoviTrajanjaService.lotbrojeviPopisRokoviTrajanja(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        this.lotRokovi = res.data;
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

}
